export const getArrivalDate = (props) => {
  const lastBound = (props?.bounds ?? []).at(-1);
  const lastSegment = (lastBound?.segments ?? []).at(-1);
  return lastSegment?.arrivedAt ?? null;
};
